 
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  micPermissionError: false,
  hasTriedMicPermission: false,
  micPermissionModalLocked: false,
  hasTriggeredMicModal: false, 
};

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setMicPermissionError: (state, action) => {
      state.micPermissionError = action.payload;
    },
    setHasTriedMicPermission: (state, action) => {
        state.hasTriedMicPermission = action.payload;
    },
    setMicPermissionModalLocked: (state, action) => {
        state.micPermissionModalLocked = action.payload;
      },
    setHasTriggeredMicModal: (state, action) => {
        state.hasTriggeredMicModal = action.payload;
    },
  },
});

export const { setMicPermissionError,setHasTriedMicPermission, setMicPermissionModalLocked,
    setHasTriggeredMicModal } = permissionsSlice.actions;

export default permissionsSlice.reducer;
